import { aws_bucket, baseURL, env, uploads_cdn } from '../../components/config';
import { errorToast } from '../../utils/toast';
import queryString from 'query-string';

export const getUploadUrl = async ({ file, module, recordID, display_name } = {}) => {
  const params = {
    bucket: aws_bucket,
    ContentType: file?.type,
    Key: 'sales-portal/' + env + `/${module}/` + recordID + '/' + display_name,
  };

  const url = `${baseURL}/generate-put-url?${queryString.stringify(params)}`;

  const response = await fetch(url, {
    headers: {
      'Content-Type': params.ContentType,
    },
  });

  if (!response.ok) {
    const text = await response.text();
    console.error('Upload URL API error:', text);
    throw new Error(`Failed to generate upload URL. Status: ${response.status}`);
  }

  return response.json();
};

export const uploadFileToS3 = async (uploadUrl, file, contentType) => {
  const response = await fetch(uploadUrl.putURL, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': contentType,
    },
  });
  if (response.status !== 200) {
    errorToast('File upload failed.');
    throw new Error('File upload failed.');
  }
};

export const getFileUrl = (path, id, fileName) => {
  return `${uploads_cdn}/sales-portal/${env}/${path}/${id}/${fileName}`;
};

export function getNewFileName(oldFileName) {
  const extension = oldFileName?.slice(oldFileName?.lastIndexOf('.'));
  const baseName = oldFileName?.slice(0, oldFileName?.lastIndexOf('.'));
  const randomString = Math.random().toString(36).substring(2, 12);
  return `${baseName}-${randomString}${extension}`;
}

export function extractOriginalFileName(modifiedFileName) {
  const extensionIndex = modifiedFileName?.lastIndexOf('.');
  modifiedFileName?.slice(extensionIndex);
  const randomStringPattern = /-\w{10}(?=\.\w+$)/;
  const baseName = modifiedFileName?.replace(randomStringPattern, '');
  return baseName;
}
